import { CommonModule } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, RouterModule } from '@angular/router'; 
import { MatCardModule } from '@angular/material/card';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { ModulePermissionServiceService } from '../../../domain/services/module-permission/module-permissio.service';
import { ModuleOption } from '../../../domain/models/modulePermission/moduleOption';
import { ModulePermission } from '../../../domain/models/modulePermission/modulePermission';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { ModuleOptionSection } from '../../../domain/models/modulePermission/moduleOptionSection';

@Component({
  selector: 'app-permissions',
  standalone: true,
  imports: [
    MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatButtonToggleModule,
        FormsModule,
        MatPaginatorModule,
        RouterModule,
        MatTableModule,
        MatInputModule,
        MatSortModule,
        MatSelectModule,
        CommonModule,
        MatDatepickerModule,
        MatNativeDateModule, 
        MatTableModule,
        MatTabsModule,
        MatCardModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatCheckboxModule,
        MatExpansionModule
  ],
  templateUrl: './permissions.component.html',
  styleUrl: './permissions.component.css'
})
export class PermissionsComponent implements AfterViewInit {
  
  modules: ModulePermission[] =[];
 constructor( private readonly service: ModulePermissionServiceService,private readonly route: ActivatedRoute) {
      }
  ngAfterViewInit(): void {
      const id: number = Number(this.route.snapshot.params['id']);
    if (id) {
  this.service.getAllbyUserGroup(id).subscribe(data => {
        this.modules = data
        console.log(data)
         
      });
    }
  
  }
 
  public saveOptions(){
    this.service.saveUserGroupsPermission(this.modules).subscribe(data => {


      });;
  }

  /** Number of enabled options within a module (for the panel summary). */
  enabledCount(module: ModulePermission): number {
    return (module.moduleOptions ?? []).filter(o => o.hasPermissions).length;
  }

  /** Current access level for an option or section: 'edit' implies 'view'. */
  getLevel(item: ModuleOption | ModuleOptionSection): 'view' | 'edit' | null {
    if (item.canEdit) {
      return 'edit';
    }
    if (item.canView) {
      return 'view';
    }
    return null;
  }

  /** Set the access level, keeping canView/canEdit consistent (edit implies view). */
  setLevel(item: ModuleOption | ModuleOptionSection, level: 'view' | 'edit' | null): void {
    if (level === 'edit') {
      item.canView = true;
      item.canEdit = true;
    } else if (level === 'view') {
      item.canView = true;
      item.canEdit = false;
    } else {
      item.canView = false;
      item.canEdit = false;
    }
  }
}
